import React from "react";
import MainSlider from "./MainSlider";
import Ourcompany from "./Ourcompany";
import Services from "./Services";
import Industry from "./Industry";
import Business from "./Business";

export default function Home(){
    return(
        <>
        <MainSlider/>
    <Ourcompany/>
    {/* <Services/> */}
    <Industry/>
    <Business/>
        </>
    )
}